import { createBookingCancellationRequest } from "../../data/bookingCancellationApi";
import { validateBookingCancellationPayload } from "../validator/validateBookingCancellationPayload";

export async function createBookingCancellationUseCase(payload) {
  const error = validateBookingCancellationPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createBookingCancellationRequest(payload);
}
